export default "__VITE_ASSET__BvrU7_ML__"